import { useState, useEffect } from "react";
import { Products, UserDetails } from "../common/Utils";
import axios from "axios";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { companyDetails } from "../common/Utils";
import { useMediaQuery } from "react-responsive";
import Lakshmi from "../assets/images/lakshmi.jpg";
const Pricelistpage = () => {
  console.log(Products.map((item) => item.price));
  const isMobile = useMediaQuery({ maxWidth: 768 });
  let { mobileNum } = useParams();
  const offer = mobileNum?.slice(5, 7) || 70;
  mobileNum = mobileNum?.slice(0, 5) + mobileNum?.slice(7, 12);
  const [price, setPrice] = useState({});
  const [validation, setValidation] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  const filteredData = Object.fromEntries(
    Object.entries(price).filter(
      ([key, value]) =>
        !["Name", "City", "District", "Pincode", "Whatsapp"].includes(key)
    )
  );

  const checkValidation = () => {
    let validate = {};
    validate.Name = StringValidation(price.Name);
    validate.City = StringValidation(price.City);
    validate.District = StringValidation(price.District);
    validate.Pincode = StringValidation(price.Pincode);
    validate.Whatsapp = StringValidation(price.Whatsapp);
    setValidation(validate);
    const check = Object.keys(validate).every(
      (data) => validate[data]?.error === false
    );

    return check;
  };

  useEffect(() => {
    setIsFormValid(checkValidation());
  }, [price]);
  const handleChange = (e, key) => {
    setPrice({
      ...price,
      [key]: {
        productName: Products?.find((obj) => obj?.name === key)?.product,
        qty: Number(e.target.value),
        total:
          Products?.find((obj) => obj?.name === key)?.price * e.target.value,
      },
    });
  };
  const handleUserData = (e, key) => {
    setPrice({ ...price, [key]: e.target.value });
    setValidation({ ...validation, [key]: false });
  };
  const StringValidation = (value) => {
    if (!value) {
      return { error: true, message: `Field is required` };
    }
    return { error: false, message: "" };
  };
  // Calculate totals separately
  const { giftBoxTotal, normalTotal } = Object.values(filteredData).reduce(
    (acc, val) => {
      const productName = val.productName || "";
      if (productName.includes("GIFT BOX")) {
        acc.giftBoxTotal += val.total; // no discount
      } else {
        acc.normalTotal += val.total; // discount applies
      }
      return acc;
    },
    { giftBoxTotal: 0, normalTotal: 0 }
  );

  // Apply discount only on normal items
  const discountAmount = (normalTotal * offer) / 100;
  const Total = giftBoxTotal + normalTotal;          // original total
  const FinalTotal = giftBoxTotal + (normalTotal - discountAmount); // after discount

  let message;

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validate = {};
    validate.Name = StringValidation(price.Name);
    validate.City = StringValidation(price.City);
    validate.District = StringValidation(price.District);
    validate.Pincode = StringValidation(price.Pincode);
    validate.Whatsapp = StringValidation(price.Whatsapp);
    setValidation(validate);
    if (
      Object.keys(validate).every((data) => validate[data]?.error === false)
    ) {
      const inputvalue = { ...price, offer: offer };
      console.log(inputvalue);
      let formdata = new FormData();
      for (let key in inputvalue) {
        const value = inputvalue[key];

        // If it's a product object with productName, send as JSON string
        if (typeof value === "object" && value.productName) {
          formdata.append(key, JSON.stringify(value));
        } else {
          formdata.append(key, value);
        }
      }

      await axios.post(
        'https://script.google.com/macros/s/AKfycbxeglf5EA53gXr_djFwgQI1M18cP1EL4fMeiI1pMV22JnGMI_F2HQzKbqmFXctuwVX7/exec',
        formdata
      );
    }
    setPrice({});
  };
  const shareInWhatsapp = () => {
    const inputvalue = price;
    let formdata = new FormData();
    for (let key in inputvalue) {
      formdata.append(key, inputvalue[key]?.qty || inputvalue[key]);
    }
    const messageBody = [...formdata];
    const findObj = (key) => {
      const d = Products.filter((a) => a.name === key)[0]?.product;
      return d;
    };
    const nameIndex = messageBody.findIndex((item) => item[0] === "Name");
    const arrayToObject = messageBody.map(([key, value]) => ({
      [findObj(key)]: value,
    }));
    const orderDetails = arrayToObject
      .filter((item) => !item.hasOwnProperty("undefined"))
      .map((item) => {
        const [key, value] = Object.entries(item)[0];
        return `${key.toLowerCase()}: ${value}`;
      })
      .join("\n");
    const customerDetails = messageBody
      .slice(nameIndex)
      .map((item) => `${item[0]}: ${item[1]}`)
      .join("\n");
    message = `*Order Details:*\n${orderDetails}\n\n*Total Amount : ${Total - discountAmount
      }*\n\n*Customer Details:*\n${customerDetails}`;
    let whatsappUrl;
    if (mobileNum) {
      whatsappUrl = `https://wa.me/91${mobileNum}?text=${encodeURIComponent(
        message
      )}`;
    } else {
      whatsappUrl = `https://wa.me/919500139626?text=${encodeURIComponent(
        message
      )}`;
    }
    window.open(whatsappUrl, "_blank");
    setPrice({});
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(8);
    doc.text(companyDetails.name, 20, 20);
    doc.text(companyDetails.address, 20, 25);
    doc.text(`Phone: ${companyDetails.phone}`, 20, 30);
    doc.text(`Email: ${companyDetails.email}`, 20, 35);

    doc.text("Estimate", 105, 10, null, null, "center");

    doc.text("customer Details:", 150, 20);
    doc.text(price.Name, 150, 25);
    doc.text(`${price.City},${price.District},${price.Pincode}`, 150, 30);
    doc.text(`Phone: ${price.Whatsapp}`, 150, 35);

    const tableColumn = ["S.No", "Item", "Quantity", "Amount"];
    const tableRows = [];
    let totalSum = 0;
    let totalQty = 0;
    let serialNumber = 1;
    for (const [key, value] of Object.entries(filteredData)) {
      console.log(value);

      // ✅ Check if it's a Gift Box
      const isGiftBox =
        key.toLowerCase().includes("giftbox") ||
        value.productName?.toUpperCase().includes("GIFT BOX");

      // ✅ Apply discount only if not a gift box
      const discountedTotal = isGiftBox
        ? value.total
        : (value.total * (100 - offer)) / 100;

      const itemData = [
        serialNumber,
        value.productName,
        value.qty,
        discountedTotal.toFixed(isGiftBox ? 0 : 2), // whole number for gift box
      ];

      tableRows.push(itemData);
      totalSum += discountedTotal;
      totalQty += value.qty;
      serialNumber++;
    }

    tableRows.push(["", "Total", totalQty, totalSum.toFixed(2)]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      theme: "plain", // Use a minimal table theme
      styles: {
        fontSize: 8, // Set font size for table
        cellPadding: 2, // Reduce cell padding
        lineWidth: 0.1, // Add this line for border width
        lineColor: [0, 0, 0], // Add this line for border color (black)
      },
      tableLineWidth: 0.1, // Add border width to table
      tableLineColor: [0, 0, 0], // Add border color to table (black)
    });


    doc.save("invoice.pdf");
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [currentImage, setCurrentImage] = useState("");
  const [tab, setTab] = useState("img");
  const openModal = (video, img) => {
    setCurrentVideo(video);
    setCurrentImage(img);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentVideo(""); // Clear the video when closing the modal
  };

  const categories = ["SPARKLERS"];
  const handleSelectChange = (event) => {
    const targetId = event.target.value;
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="container content-body">
      <h2 className="text-center mb-4">Price List</h2>

      <div className="price-list d-flex justify-content-center">
        {isMobile ? (
          <div className="d-flex flex-column">
            {/* <select onChange={handleSelectChange}>
              {categories.map((item, i) => (
                <option key={i} value={item}>
                  {item}
                </option>
              ))}
            </select> */}
            <div>
              {Products.map((item, i) => {
                return (
                  <>
                    {item?.Title ? (
                      <button key={i} id={item?.Title} className="list-mb-head">
                        {item?.Title}
                      </button>
                    ) : (
                      ""
                    )}
                    <div key={i} className="mobileLayout">
                      <div>
                        <p className="text-center mb-0 fw-bold mobileProduct dark-blue">
                          {item.product} - {item?.unit}
                        </p>
                      </div>
                      <div className="d-flex">
                        <div>
                          {(item.image || item.video) &&
                            <img
                              src={Lakshmi}
                              alt="crackers"
                              className="productImage"
                              onClick={() => openModal(item.video, item.image)}
                            />
                          }
                        </div>
                        <div className="d-flex flex-fill align-items-center">
                          <div className="text-center w-50">
                            <small className="mb-0 text-decoration-line-through strikePrice dark-blue">
                              &#8377; {item.product.includes("GIFT BOX") ? '' : item.price}
                            </small>
                            <p className="mb-0 fw-bold dark-blue">
                              &#8377; {
                                item.product.includes("GIFT BOX")
                                  ? item.price.toFixed(0)
                                  : (item.price - (item.price * offer) / 100).toFixed(2)
                              }
                            </p>

                          </div>
                          <div className="w-25">
                            <input
                              type="tel"
                              name={item.name}
                              placeholder="0"
                              onChange={(e) => {
                                handleChange(e, item.name);
                              }}
                              value={price[item?.name]?.qty}
                              maxLength={3}
                              className="mobileInput text-center"
                            />
                          </div>
                          <div className="w-25">
                            <p className="mb-0 text-end me-2">
                              {price[item?.name]?.qty
                                ? (
                                  item.product.includes("GIFT BOX")
                                    ? (item.price * price[item?.name]?.qty).toFixed(0)
                                    : ((item.price * price[item?.name]?.qty * (100 - offer)) / 100).toFixed(2)
                                )
                                : 0}

                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th className="code-column">Code</th>
                <th className="product-column">Product</th>
                <th className="media-column">Media</th>
                <th className="unit-column">Unit</th>
                <th className="price-column">Price</th>
                <th className="input-column">Quantity</th>
                <th className="input-column2">Qty</th>
                <th className="amount-column">Sum</th>
              </tr>
            </thead>
            <tbody>
              {Products.map((item, i) => {
                return (
                  <>
                    {item.Title && (
                      <tr>
                        <td colSpan={7} className="list-header">
                          {item.Title}
                        </td>
                      </tr>
                    )}
                    <tr key={i}>
                      <td className="text-center">{i + 1}</td>
                      <td className="">{item.product}</td>
                      <td className="media-icons">
                        {item.image &&
                          <a href={item.image} target="_blank">
                            <i class="fa-regular fa-image"></i>
                          </a>}
                        {item.video &&
                          <a
                            href={`https://www.youtube.com/embed/${item.video}`}
                            target="_blank"
                          >
                            <i class="fa-solid fa-video"></i>
                          </a>}
                      </td>
                      <td className="unit-data">{item.unit}</td>
                      <td className="price-data d-flex justify-content-between">
                        <p className=" text-center text-decoration-line-through">
                          {item.product.includes("GIFT BOX") ? '' : item.price.toFixed(2)}
                        </p>
                        <h6 className="mb-0 text-center">
                          {
                            item.product.includes("GIFT BOX")
                              ? item.price.toFixed(0) // no discount
                              : ((item.price * (100 - offer)) / 100).toFixed(2) // with discount
                          }
                        </h6>

                      </td>
                      <td className="input-data">
                        <input
                          type="tel"
                          name={item.name}
                          placeholder="0"
                          onChange={(e) => {
                            handleChange(e, item.name);
                          }}
                          value={price[item?.name]?.qty}
                          maxLength={3}
                        />
                      </td>
                      <td>
                        {price[item?.name]
                          ? (
                            item.product.includes("GIFT BOX")
                              ? (item.price * price[item?.name]?.qty).toFixed(0) // no discount
                              : ((item.price * price[item?.name]?.qty * (100 - offer)) / 100).toFixed(2)
                          )
                          : 0}

                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div className="d-flex  justify-content-center sticky-total-tab">
        <div className="price-tab">
          <table className="table-borderless w-100">
            <tr>
              <td className="w-25 text-center">
                <small className="">Actual</small>
              </td>
              <td className="w-25 text-center">
                <small>Discount {offer}% </small>
              </td>
              <td className="w-25 text-center">
                <small>Final Price</small>
              </td>
            </tr>
            <tr>
              <td className="w-25 text-center">&#8377; {Total.toFixed(2)}</td>
              <td className="w-25 text-center">
                &#8377; {discountAmount.toFixed(2)}
              </td>
              <td className="w-25 text-center">
                &#8377; {(Total - discountAmount).toFixed(2)}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div className="my-5">
        <h5 className="text-center">Billing Address</h5>
        <div className="row g-3 px-5">
          {UserDetails.map((user) => {
            return (
              <div className="col-lg-4">
                <label>
                  {user.name === "Whatsapp" ? "Whatsapp Number" : user.name}
                </label>
                <br />
                <input
                  className="customer-input"
                  name={user.name}
                  placeholder={`Enter ${user.name}`}
                  value={price[user.name]}
                  onChange={(e) => handleUserData(e, user.name)}
                />
              </div>
            );
          })}
        </div>
        <div className="text-center mt-5 d-md-block d-flex flex-column align-items-center">
          <button
            className="btn btn-primary w-auto"
            onClick={(e) => {
              handleSubmit(e);
              generatePDF(e);
            }}
            disabled={!isFormValid}
          >
            Submit and print pdf
          </button>
          <button
            onClick={shareInWhatsapp}
            className="ms-lg-5 mt-lg-0 mt-4 btn btn-success"
            disabled={!isFormValid}
          >
            Share in Whatsapp
          </button>
        </div>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3935.325669757028!2d77.8232718!3d9.4803763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cffe27b4d11d%3A0x5340929726fd9fc6!2sRanjitham%20Crackers%20Gallery!5e0!3m2!1sen!2sin!4v1722876241431!5m2!1sen!2sin" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
        }}
      />
      {modalIsOpen && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={closeModal}>
                  &times;
                </button>
              </div>
              {tab === "img" ? (
                <div className="modal-body">
                  <img src={currentImage} className="modal-image" />
                </div>
              ) : (
                <div className="modal-body">
                  <iframe
                    width="100%"
                    height="315"
                    src={`https://www.youtube.com/embed/${currentVideo}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="YouTube video"
                  ></iframe>
                </div>
              )}
              <div className="row align-items-center modal-btns">
                <div className="col-6 d-flex justify-content-center">
                  <button onClick={() => setTab("img")}>
                    <i class="fa-solid fa-image"></i>
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button onClick={() => setTab("vdo")}>
                    <i class="fa-brands fa-youtube"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Pricelistpage;
